import { render, staticRenderFns } from "./CreditosComp.vue?vue&type=template&id=ce32b7bc&scoped=true&lang=pug&"
import script from "./CreditosComp.vue?vue&type=script&lang=js&"
export * from "./CreditosComp.vue?vue&type=script&lang=js&"
import style0 from "./CreditosComp.vue?vue&type=style&index=0&id=ce32b7bc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce32b7bc",
  null
  
)

export default component.exports